module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/424.a3cb0242.png";